import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/shop-agreement/response";
import * as ShopAgreementAPI from "@/api/shop-agreement";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/shop-agreement/request";

const MODULE_NAME = "shop-agreement/get";

/**
 * 店舗契約情報取得API（/get-shop-agreement）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getagreementsList() {
    if (this.getResponse.agreementsList) {
      return this.getResponse.agreementsList || [];
    } else {
      return [];
    }
  }

  // MutationActions
  @MutationAction
  async get(getRequest: GetRequest) {
    const getResponse = await ShopAgreementAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
